import { render, staticRenderFns } from "./ProjectPhotos.vue?vue&type=template&id=4d6c53bc&"
import script from "./ProjectPhotos.vue?vue&type=script&lang=js&"
export * from "./ProjectPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d6c53bc')) {
      api.createRecord('4d6c53bc', component.options)
    } else {
      api.reload('4d6c53bc', component.options)
    }
    module.hot.accept("./ProjectPhotos.vue?vue&type=template&id=4d6c53bc&", function () {
      api.rerender('4d6c53bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/ProjectPhotos.vue"
export default component.exports